<template>

    <div class="qtype-1 dd-m-card dd-m-card--quiz-question" :id="'dd-question-' + item.id">
        <h2 class="dd-m-card--quiz-question__title">
            {{item.text}}
            <div class="dd-m-alert dd-m-alert--danger" v-if="hasError">
                <p>{{ getTranslateString('Answer all questions to complete the quiz') }}</p>
            </div>
        </h2>

        <ul class="dd-m-card--quiz-question__answers dd-m-card--quiz-question__answers--type-1">
            <li class="dd-m-card--quiz-question__item"
                v-for="(answer, index) in item.answers"
                :key="index"
                v-bind:class="{ 'is-selected': hasAnswer(answer.id) }">
                <input v-model="selected"
                       type="checkbox"
                       :value="answer.id"
                       @change="updateAnswer(answer.id)"
                       class="dd-m-card--quiz-question__input"/>

                <label class="dd-m-card--quiz-question__label dd-m-card--quiz-question__label--custom">
                    {{answer.text}}
                    <img v-if="answer.image" :src="answer.image ? answer.image.mobile :''"/>
                    
                </label>
            </li>
        </ul>
    </div>

</template>
<script>
    import ScrollService from "../../providers/scroll";

    const scrollService = new ScrollService();

    export default {
        name: 'card-question-type-1',
        props: ['item', 'offline'],
        data: () => {
            return {
                selected: [],
                results: [],
                hasError: false
            }
        },
        mounted() {
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('showError', (msg, param) => {
                    if (this.item.id === param) {
                        this.hasError = true;

                        if (this.offline) {
                            scrollService.doSmoothScrollToFromModal(this.item.offset, 20);
                        } else {
                            scrollService.doSmoothScrollTo(`#dd-question-${this.item.id}`, 138);
                        }
                    }
                });
            },
            hasAnswer(value) {
                return this.selected.includes(value);
            },
            updateAnswer(value) {
                this.hasError = false;
                PubSub.publish('updateAnswers', value);
                PubSub.publish('updateQuestionsAnswered', {value: this.item.id, remove: !this.selected.length});
                PubSub.publish('goToNextQuestion', this.item.id);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/quiz/card-question-type-1.vue